export enum ContactAddressType {
  BillingAddress = 'BillingAddress',
}
